import en from './TranslationsEn'
import jp from './TranslationsJp'

// jsonを結合する
var localization = Object.assign(en, jp)

export {
    localization
}


